import {useState, useEffect} from "react";
import {Link} from 'react-router-dom';
import moment from 'moment';
import {  Table, Select, DatePicker, Spin, Input,Empty,Tag,Skeleton,Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell} from 'recharts';

import * as Styled from './style.js';
import { getData } from '../../config/api-connect';
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const { Option } = Select;
const { TextArea } = Input;

const COLORS = ['#39b351','#0088FE', '#FFBB28', '#FF8042', '#FF6F61', '#6A67CE', '#00C49F'];

const CollectionList = () => {
  var today = new Date();
  var local_month = JSON.parse(localStorage.getItem('month'));
  var local_year = JSON.parse(localStorage.getItem('year'));

  if(local_month){
   var mm = local_month
  }else{
      var mm = String(today.getMonth() + 1).padStart(2, '0')
  }

  if(local_year) {
    var yyyy = local_year
  }
  else {
    var yyyy = today.getFullYear()
    yyyy = yyyy.toString()
  }

  var local_city = JSON.parse(localStorage.getItem('cityId'))
  var local_selectedVenueId = JSON.parse(localStorage.getItem('selectedVenueId'))
  if(!local_selectedVenueId){
    local_selectedVenueId = 'All'
  }

  const [loading, setLoading] = useState(true)
  const [graphLoading, setGraphLoading] = useState(false)
  const [pieLoading,setPieLoading] = useState(false)
  const [venues, setVenues] = useState([])
  const [cities, setCities] = useState([])
  const [cityId, setCityId] = useState(local_city)
  const [venuelist, setVenuelist] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(local_selectedVenueId)
  const [collectionData, setCollectionData] = useState([])
  const [month, setMonth] = useState(mm)
  const [year, setYear] = useState(yyyy)
  const [graphData, setGraphData] = useState({})
  const [totalData, setTotalData] = useState({})
  const [pieGraphData, setPieGraphData] = useState([])
  const [totalCollection, setTotalCollection] = useState('')
  const [totals, setTotals] = useState({
    total: 0,
    adults: 0,
    court_booking: 0,
    others: 0,
    academy: {}
  });

  useEffect(() => {
    localStorage.setItem('month', JSON.stringify(month));
    localStorage.setItem('year', JSON.stringify(year));
    localStorage.setItem('selectedVenueId',JSON.stringify(selectedVenueId))
    localStorage.setItem('cityId',JSON.stringify(cityId))
  }, [month,year,selectedVenueId,cityId]);

  useEffect(() => {
     getVenues()
  }, []); 

  useEffect(() => {
    if(cityId !== ''){
      setLoading(true)
      getCollection()
      getCollectionSplit()
    }
  }, [month,year,selectedVenueId,cityId]); 

  useEffect(()=> {
    if(cityId !== ''){
      getCollectionGraph()
    }
  },[selectedVenueId,cityId])

  useEffect(() => {
    if(cities.length){
      getVenuesInCity()
    }
  }, [cities,cityId]);

  const handleCityChange = (value) => {
    if (value.length > 0) {
      const last_selected = value[value.length - 1]
      if(last_selected == 'All'){
        setCityId(['All']);
      }
      else{
        const filtered = value.filter(v => v !== 'All');
        setCityId(filtered)
      }
    }
    else {
      setCityId(['All']);
    }
  };

  const getVenuesInCity =() =>{
    if(cities[0] && !cityId){
      setCityId([cities[0].id])
    }

    let filteredVenues;

    if (cityId === 'All' || (Array.isArray(cityId) && cityId.includes('All')) ) {
      filteredVenues = venues;
    } else {
      filteredVenues = Array.isArray(cityId) ? venues.filter(item => cityId.includes(item.city)) : venues ;
    }

    setVenuelist(filteredVenues);
    const venueExists = filteredVenues.some(item => item.id === selectedVenueId);
    if (!venueExists) {
      setSelectedVenueId('All');
    }
  }

  const getVenues = async () => {
    await getData('/business/get_venues_for_buddies/')
    .then(response =>{
      setVenues(response.result)
      setCities(response.cities)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const onChangeYear = (date, dateString) => {
    setYear(dateString);
  };  

  const getCollection = () => {
    getData(`/business/get_collection_overview/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setCollectionData(response.result)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
      console.log(error.message);
    });
  }

  const formatIndianCurrency = (value) => {
    return Number(value).toLocaleString('en-IN')
  };

  const getCollectionSplit = () => {
    setPieLoading(true)
    getData(`/business/get_collection_split_up_by_mode/?month=${month}&year=${year}&venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setPieGraphData(response.result)
      setTotalCollection(response.total_collection)   
      setTotalData(response.number_box_data)   
    })
    .catch(error => {
      console.log(error.message);
    })
    .finally(()=>{
      setPieLoading(false)
    })
  }

  const getCollectionGraph = () => {
    setGraphLoading(true)
    getData(`/business/get_collection_graph/?venue_id=${selectedVenueId}&city_id=${cityId}`)
    .then(response =>{
      setGraphData(response.result) 
      setGraphLoading(false);
    })
    .catch(error => {
      setGraphLoading(false)
      console.log(error.message);
    });
  }

  const renderHeader = (title,type) => {
    return(
      <div style={{ textAlign: 'center', fontWeight: type ? 'normal' :'bold' }}>{title}</div>
    )
  }  

  const renderCollectionCustomer = (data,page,venue_id,type) => {
    return(
      page != null ?
        <Link to={`/collection/${venue_id}/${page}`} className='venueTitle'>
          <div style={{fontWeight: 'bold' }}>{formatIndianCurrency(data.collection)}</div>
          <Styled.RevenueCol>
            <div style={{color:'grey'}}>{data.tickets}</div>
            <ArrowRightOutlined />
          </Styled.RevenueCol>
        </Link>
      :
        <div>
          <div style={{fontWeight: !type && 'bold' }}>{formatIndianCurrency(data.collection)}</div>
          <div style={{color:'grey'}}>{data.tickets}</div>
        </div>
    )
  }
  const allLevels = collectionData[0]?.academy?.data?.map(item => item.name) || [];

  const levelNames = allLevels.filter(level =>
    collectionData.some(venue =>
      venue.academy?.data?.some(item => item.name === level && item.collection > 0)
    )
  );

  const academyColumn = {
    title: renderHeader('Academy'),
    align: 'center',
    children: [
      ...levelNames.map(level => ({
        title: renderHeader(level,'normal'),
        width: 110,
        dataIndex: ['academy', 'data'],
        align: 'right',
        render: (data = [], record) => {
          const item = data.find(d => d.name === level);
          if (!item) return null;

          return renderCollectionCustomer(item,null,null,'normal');
        },
      })),

      {
        title: renderHeader('Total'),
        dataIndex: 'academy',
        width: 110,
        align: 'right',
        render: (value, record) => renderCollectionCustomer(value),
      },
    ],
  };

  const columns = [
    {
      title: renderHeader('Venue'),
      dataIndex: 'venue',
      width: 300,
      render: (value) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Link to={`/collection-summary/${value.venue_id}/${value.name}`} className='venueTitle'>
              {value.name}
            </Link>
            {!value.is_active && (
              <Tag color="red" style={{ margin: 0 }}>
                Inactive
              </Tag>
            )}
          </div>
        );
      }
    },
    {
      title: renderHeader('Total'),
      dataIndex: 'total',
      render: (value) => renderCollectionCustomer(value),
      align: 'right',
      width: 100,
    },
    academyColumn,
    {
      title: renderHeader('Adults'),
      dataIndex: 'adults',
      render: (value, record) => renderCollectionCustomer(value),
      align: 'right',
      width: 110,
    },
    {
      title: renderHeader('Court Booking'),
      dataIndex: 'court_booking',
      render: (value, record) => renderCollectionCustomer(value, 'courtbooking', record.venue.venue_id),
      align: 'right',
      width: 110,
    },
    {
      title: renderHeader('Others'),
      dataIndex: 'others',
      render: (value, record) => renderCollectionCustomer(value),
      align: 'right',
      width: 110,
    },
    {
      title: '',
      width:10,
      dataIndex: 'venue',
      render: (value) => {
        return(
          <Link to={`/collection-summary/${value.venue_id}/${value.name}`} className='venueTitle'>
            <ArrowRightOutlined/>
          </Link>
          )
      }
    }
  ]

  useEffect(() => {
    const calcTotals = {
      total: 0,
      adults: 0,
      court_booking: 0,
      others: 0,
      academy: {}
    };

    collectionData.forEach(({ total, adults, court_booking, others, academy }) => {
      calcTotals.total += total?.collection || 0;
      calcTotals.adults += adults?.collection || 0;
      calcTotals.court_booking += court_booking?.collection || 0;
      calcTotals.others += others?.collection || 0;

      // Academy level totals
      academy?.data?.forEach((level) => {
        calcTotals.academy[level.name] =
          (calcTotals.academy[level.name] || 0) + (level.collection || 0);
      });

      // Academy total
      calcTotals.academy.total =
        (calcTotals.academy.total || 0) + (academy?.collection || 0);
    });

    setTotals(calcTotals);
  }, [collectionData]);
  

  return (
    // <Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>

        <Styled.TopDiv>    
          <Styled.SelectorContainer>

            {cities.length > 1 &&        
              <Styled.Selector>
                <span className='indicatorText'>City</span>
                <Select
                  mode="multiple"
                  className = 'mainSelector'
                  style={{width: 150}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={handleCityChange}
                  value = {cityId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {
                    cities.map(item=>(
                      <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }
            {venuelist && venuelist.length > 0 &&
              <Styled.Selector>
                <span className='indicatorText'>Venue</span>
                <Select
                  className = 'mainSelector'
                  style={{width: 300}}
                  showSearch = {true}
                  placeholder="Search to Select"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.name.toLowerCase().includes(input.toLowerCase())}
                  onChange={setSelectedVenueId}
                  value = {selectedVenueId}
                  bordered={false}
                >
                  <Option value="All" name="All"> All </Option>
                  {venuelist.map(item=>(
                    <Option value={item.id} key={item.id} name = {item.name}> {item.name} </Option>    
                    ))
                  }
                </Select>
              </Styled.Selector>
            }  
          </Styled.SelectorContainer>

          <div style={{display: 'flex'}}>
            <Styled.Selector>
              <span className='indicatorText'>Month</span>
              <Select
                  className = 'mainSelector'
                  style={{width: 150}}
                  onChange={setMonth}
                  value = {month}
                  bordered={false}
                >
                  <Option value="12"> December </Option>
                  <Option value="11"> November </Option>
                  <Option value="10"> October </Option>
                  <Option value="09"> September </Option>
                  <Option value="08"> August </Option>
                  <Option value="07"> July </Option>
                  <Option value="06"> June </Option>
                  <Option value="05"> May </Option>
                  <Option value="04"> April </Option>
                  <Option value="03"> March </Option>
                  <Option value="02"> February </Option>
                  <Option value="01"> January </Option>
                </Select>
            </Styled.Selector>

            <Styled.Selector>
              <span className='indicatorText'>Year</span>
              <div className = 'mainSelector' style={{width: 100}}>
                <DatePicker defaultValue={moment(year, 'YYYY')}  onChange = {onChangeYear}  bordered={false}  picker="year" />
              </div>
            </Styled.Selector>
          </div>
        </Styled.TopDiv>

        {collectionData?.length > 0 ? 
          <Styled.NewHeader>     
            <span></span>
            <span> Collection Overview</span>
            {collectionData?.length > 0 && (
              <ReactHTMLTableToExcel
                className="btn btn-sm downloadBtn"
                table="collection-report-download"
                filename={`Collection-Overview-${month}-${year}`}
                sheet="Collection Overview"
                buttonText="Download"
              />
            )}
          </Styled.NewHeader>
        : 
          <Styled.Header>
            <span> Collection Overview </span>
          </Styled.Header>
        }

      <Styled.GraphContainer>

        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Collection - Analysis </Styled.LabelHeading>

            <Styled.GraphMonthSelector>
              Last 6 months
            </Styled.GraphMonthSelector>
          
          </Styled.GraphDivLabelDiv>
          {graphLoading ?
            <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
              <Spin />
            </div>
          :
            <ResponsiveContainer width="100%" height="80%">
              <LineChart
                width={500}
                height={300}
                data={graphData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 30,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  dataKey="month" 
                  tickFormatter={(value) => moment(value, "MMMM YYYY").format("MMM")}
                />
                <YAxis tickFormatter={formatIndianCurrency}/>
                <Tooltip formatter={(value, name) => [formatIndianCurrency(value), name]}/>
                <Legend />
                {/*<Line type="monotone" dataKey="collection" stroke="#02475c" />*/}
                <Line type="monotone" dataKey="total_collection" stroke="#1e7c0a" name="Total Collection"/>
                <Line type="monotone" dataKey="academy" stroke="#c48e1a" name="Academy"/>                
                <Line type="monotone" dataKey="adults" stroke="#4345ab" name="Adults"/>
                <Line type="monotone" dataKey="court booking" stroke="#5676f5" name="Court Booking"/>
                <Line type="monotone" dataKey="others" stroke="#470053" name="Others"/>
              </LineChart>
            </ResponsiveContainer>
          }
        </Styled.GraphDiv>

        <span></span>
        <Styled.GraphDiv>
          <Styled.GraphDivLabelDiv>
            <Styled.LabelHeading> Payment Mode Split Up </Styled.LabelHeading>
          </Styled.GraphDivLabelDiv>
            { pieLoading ?
                <div style={{ height: '30vh',display: 'flex',alignItems: 'center',justifyContent: 'center' }}>
                  <Spin />
                </div>
              :
              totalCollection > 0 ?
                <Styled.PieDiv>
                  <div style={{position: 'relative',height:'fit-content'}}>
                    <PieChart width={200} height={200}>
                      <Pie
                        data={pieGraphData}
                        innerRadius={60}
                        // outerRadius={80}
                        fill="#8884d8"
                        // paddingAngle={5}
                        dataKey="collection"
                      >
                        {pieGraphData.map((entry, index) => (
                          <Cell key={`cell-${entry}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Pie>
                    </PieChart>
                    <Styled.TotalAmount> {totalCollection.toLocaleString('en-IN')} </Styled.TotalAmount>
                  </div>   
                  <Styled.PieDivInfo>
                    {
                      pieGraphData.map((item,index)=>(
                        <Styled.InfoRow>
                          <Styled.InfoColor style={{backgroundColor: COLORS[index % COLORS.length]}} />
                          <Styled.InfoLabel> {item.payment_mode} - {item.collection.toLocaleString('en-IN')}</Styled.InfoLabel>
                        </Styled.InfoRow>
                      ))
                    }  
                  </Styled.PieDivInfo>
                </Styled.PieDiv>
              :
                <Empty style={{marginTop: '10%'}} description = {<span style={{color: 'grey', fontSize: 'small'}}> data not available </span>} />
            }

        </Styled.GraphDiv>
      </Styled.GraphContainer>
      {totalData && !pieLoading &&
        <Styled.StatsDiv>
          <Styled.StatsBox>
            <Styled.StatsLabel>Month - </Styled.StatsLabel> 
            {totalData.month ? totalData.month : ''}
          </Styled.StatsBox>
          <a></a>
          <Link to={`/collections/total/`}>
            <Styled.TotalBox primary={!totalData.total || totalData.total.collection == 0}>
              <span></span>
              <span style={{display:'flex'}}>
              <Styled.StatsLabel>Total Collection - </Styled.StatsLabel>
                {totalData.total && totalData.total.collection && totalData.total.collection.toLocaleString('en-IN')} 
                &nbsp;
                {totalData.total && totalData.total.tickets ? `(${totalData.total.tickets.toLocaleString('en-IN')})` : ''}
              </span>
              <ArrowRightOutlined />
            </Styled.TotalBox>
          </Link>
          <a></a> 
          <Styled.StatsBox>
            <Styled.StatsLabel>Verified - </Styled.StatsLabel> 
            {totalData.verified && totalData.verified.collection && totalData.verified.collection.toLocaleString('en-IN')}
            &nbsp;
            {totalData.verified && totalData.verified.tickets ? `(${totalData.verified.tickets.toLocaleString('en-IN')})` : ''}
          </Styled.StatsBox>
          <a></a>
          <Link to={`/collections/unverified/`}>
            <Styled.UnverifiedBox primary={!totalData.unverified || totalData.unverified.collection == 0}>
              <span></span>
              <span style={{display:'flex'}}>
              <Styled.StatsLabel>Unverified - </Styled.StatsLabel> 
                {totalData.unverified && totalData.unverified.collection && totalData.unverified.collection.toLocaleString('en-IN')}
                &nbsp;
                {totalData.unverified && totalData.unverified.tickets ? `(${totalData.unverified.tickets.toLocaleString('en-IN')})` : ''}
                &nbsp;
              </span>
              <ArrowRightOutlined />
            </Styled.UnverifiedBox>
          </Link>
          <a></a>
        </Styled.StatsDiv>
      }

      {loading ?
        <Skeleton active paragraph={{ rows: 7 }} title={false} />
      :
        <div>
          {
            collectionData?.length > 0 &&
            <Typography.Text type="primary" style={{ fontSize: 12}}>
              * In the table, the larger numbers show the <b>collection</b> amount, while the smaller numbers below them represent the number of <b>tickets</b>.
            </Typography.Text>
          }
          <Table
            className="revenue-table table_container"
            rowKey="id"
            columns={columns}
            dataSource={collectionData}
            pagination={false}
            scroll={{ x: 'max-content' }}
            summary={() => {
              const footerValues = [
                { key: 'label', value: <b>Total</b>, align: 'Left', isLabel: true },
                { key: 'total', value: totals.total, align: 'right' },
                ...levelNames.map(level => ({
                  key: level,
                  value: totals.academy[level],
                  align: 'right'
                })),
                { key: 'academyTotal', value: totals.academy.total, align: 'right' },
                { key: 'adults', value: totals.adults, align: 'right' },
                { key: 'court_booking', value: totals.court_booking, align: 'right' },
                { key: 'others', value: totals.others, align: 'right' },
              ];

              return (
                collectionData?.length > 0 &&
                <Table.Summary.Row>
                  {footerValues.map((item, idx) => (
                    <Table.Summary.Cell key={item.key} index={idx} align={item.align || 'left'}>
                      {item.isLabel ? item.value : renderCollectionCustomer({ collection: item.value })}
                    </Table.Summary.Cell>
                  ))}
                </Table.Summary.Row>
              );
            }}
          />
          <table id="collection-report-download" style={{ display: "none" }}>
            <thead>
              <tr>
                <th rowSpan="2">Venue</th>
                <th rowSpan="2">Total</th>

                <th colSpan={levelNames.length + 1}>
                  Academy
                </th>

                <th rowSpan="2">Adults</th>
                <th rowSpan="2">Court Booking</th>
                <th rowSpan="2">Others</th>
              </tr>

              <tr>
                {levelNames.map((level) => (
                  <th key={level}>{level}</th>
                ))}

                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {collectionData.map((row, index) => {
                return (
                  <tr key={index}>
                    <td>{row.venue?.name}</td>

                    <td>{row.total?.collection || 0}</td>

                    {levelNames.map((level) => {
                      const item = row.academy?.data?.find(
                        (d) => d.name === level
                      );

                      return (
                        <td key={level}>
                          {item?.collection || 0}
                        </td>
                      );
                    })}

                    <td>{row.academy?.collection || 0}</td>

                    <td>{row.adults?.collection || 0}</td>

                    <td>{row.court_booking?.collection || 0}</td>

                    <td>{row.others?.collection || 0}</td>
                  </tr>
                );
              })}

              <tr>
                <td><b>Total</b></td>

                <td>{totals.total || 0}</td>

                {levelNames.map((level) => (
                  <td key={level}>
                    {totals.academy[level] || 0}
                  </td>
                ))}

                <td>{totals.academy.total || 0}</td>

                <td>{totals.adults || 0}</td>

                <td>{totals.court_booking || 0}</td>

                <td>{totals.others || 0}</td>
              </tr>
            </tbody>
          </table>
        </div>  
      } 
      </Styled.MainContainer>
    // </Spin>
  );
}

export default CollectionList;